import React, { useEffect, useRef, useState, useCallback,useMemo } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import MainHeader from '../../Pages/Header/HeaderForBus';
import FooterStyle from '../../Pages/Footer/Footer';
import StickTab from './StickTab';
import EmployeeReviwe from './EmployeeReviwe';
import AboutSection from './AboutSection';
import Academic from './Acedmic';
import AllReview from './AllReview';
import StarRating from '../../Components/StarRating';
import API from '../../Api/Api';
import { IMAGE_PATHS, DOMAIN_URL ,base64Decode} from '../../Functions/Constant';
import Skeleton from '../../Components/Skeleton'; // New reusable skeleton component
import { toast } from 'react-toastify'; // For user-friendly error messages
import PropTypes from 'prop-types'; // For type checking
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import About from './About';
import ConfinPop from "../../Pages/ComponentPage/ConfinPop";
// Constants
const STICKY_THRESHOLD = {
  mobile: 225,
  desktop: 205,
};
const SCROLL_OFFSET = 40;

// Tab configurations
const DEFAULT_TAB_MENU = [{ tabTitle: 'Overview', refKey: 'overviewRef' }];
const TAB_MENU = [
  { tabTitle: 'Overview', refKey: 'overviewRef' },
  { tabTitle: 'Professional Reviews', refKey: 'reviewsRef' },
  { tabTitle: 'Academic Reviews', refKey: 'academicRef' },
  { tabTitle: 'All Reviews', refKey: 'allReviewsRef' },
];

// Utility function for API calls
const fetchApiData = async (endpoint, errorMessage) => {
  try {
    const response = await API.get(endpoint);
    return response;
  } catch (error) {
    console.error(errorMessage, error);
    throw error;
  }
};

const EmployeeDetail = ({ style }) => {
  const navigate = useNavigate();
    const { id } = useParams();
  const [isSticky, setSticky] = useState(false);
  const [stickyHeight, setStickyHeight] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const stickyRef = useRef(null);
  const overviewRef = useRef(null);
  const reviewsRef = useRef(null);
  const academicRef = useRef(null);
  const allReviewsRef = useRef(null);
  const [jwtTokenJobcritic, setjwtTokenJobcritic] = useState(localStorage.getItem("jwt_token_jobcritic"));
const [userId, setUserId] = useState(null);
  const [userData, setUserData] = useState({
    name: null,
    profile_image: IMAGE_PATHS.USER,
    profile_title: '',
    about: '',
  });
  const [ratings, setRatings] = useState({
    overall_rating: 0,
    total_reviews: 0,
    is_ai_summary: 0,
    excellent: 0,
    very_good: 0,
    average: 0,
    poor: 0,
    terrible: 0,
  });
  const [mainRating, setMainRating] = useState({
    core: 0,
    creativity: 0,
    personal: 0,
    technical: 0,
    interpersonal: 0,
  });
  const [professional, setProfessional] = useState({
    ai_summary: 'No AI summary available',
    key_strengths: [],
    improvement_areas: [],
    category_ratings: null,
  });
  const [ratingsPorfin, setRatingsPorfin] = useState(null);
  const [academic, setAcademic] = useState({
    ai_summary: 'No AI summary available',
    key_strengths: [],
    improvement_areas: [],
    category_ratings: null,
  });
  const [academicRatings, setAcademicRatings] = useState(null);

  // Fetch all data in parallel
  const fetchAllData = useCallback(async (user_id,hide_data=0) => {
    setLoading(true);
    setError(null);
    try {
      const [overallRes, userRes] = await Promise.all([
        fetchApiData('/reviews/overall_rating?user_id='+user_id, 'Error fetching overall ratings'),
        fetchApiData('/user?user_id='+user_id, 'Error fetching user data'),
      ]);

      // Process user data
      if (userRes.user) {
        const user = {
          name: userRes.user.name,
          profile_image: DOMAIN_URL + userRes.user.profile_image || IMAGE_PATHS.USER,
          profile_title: userRes.user.profile_title || '',
          about: userRes.user.about || '',
        };
        setUserData(user);
        
      }
      if(hide_data==1){

      }else{
          // Process overall ratings
          if (overallRes.overall_rating) {
            setRatings({
              overall_rating: overallRes.overall_rating.overall_rating || 0,
              total_reviews: overallRes.overall_rating.total_reviews || 0,
              is_ai_summary: overallRes.overall_rating.is_ai_summary || 0,
              excellent: overallRes.overall_rating.excellent || 0,
              very_good: overallRes.overall_rating.very_good || 0,
              average: overallRes.overall_rating.average || 0,
              poor: overallRes.overall_rating.poor || 0,
              terrible: overallRes.overall_rating.terrible || 0,
            });
          }

          // Process category ratings
          if (overallRes.category_ratings) {
            setMainRating({
              core: overallRes.category_ratings.core || 0,
              creativity: overallRes.category_ratings.creativity || 0,
              personal: overallRes.category_ratings.personal || 0,
              technical: overallRes.category_ratings.technical || 0,
              interpersonal: overallRes.category_ratings.interpersonal || 0,
            });
          }

          // Process professional data
          if (overallRes.professional) {
            setProfessional({
              ai_summary: overallRes.professional.ai_summary || 'No AI summary available',
              key_strengths: Array.isArray(overallRes.professional.key_strengths)
                ? overallRes.professional.key_strengths
                : [],
              improvement_areas: Array.isArray(overallRes.professional.improvement_areas)
                ? overallRes.professional.improvement_areas
                : [],
              category_ratings: overallRes.professional.category_ratings || null,
            });
            if (overallRes.professional.overall_rating) {
              setRatingsPorfin({
                overall_rating: overallRes.professional.overall_rating ?? 0,
                total_reviews: overallRes.professional.total_reviews ?? 0,
                excellent: overallRes.professional.excellent ?? 0,
                very_good: overallRes.professional.very_good ?? 0,
                average: overallRes.professional.average ?? 0,
                poor: overallRes.professional.poor ?? 0,
                terrible: overallRes.professional.terrible ?? 0,
              });
            }
          }

          // Process academic data
          if (overallRes.academic) {
            setAcademic({
              ai_summary: overallRes.academic.ai_summary || 'No AI summary available',
              key_strengths: Array.isArray(overallRes.academic.key_strengths)
                ? overallRes.academic.key_strengths
                : [],
              improvement_areas: Array.isArray(overallRes.academic.improvement_areas)
                ? overallRes.academic.improvement_areas
                : [],
              category_ratings: overallRes.academic.category_ratings || null,
            });
            if (overallRes.academic.overall_rating) {
              setAcademicRatings({
                overall_rating: overallRes.academic.overall_rating ?? 0,
                total_reviews: overallRes.academic.total_reviews ?? 0,
                excellent: overallRes.academic.excellent ?? 0,
                very_good: overallRes.academic.very_good ?? 0,
                average: overallRes.academic.average ?? 0,
                poor: overallRes.academic.poor ?? 0,
                terrible: overallRes.academic.terrible ?? 0,
              });
            }
          }
      }
      
    } catch (error) {
      setError('Failed to load data. Please try again later.');
      toast.error('Failed to load data. Please try again.');
    } finally {
      setLoading(false);
    }
  }, []);

  // Scroll handler with debouncing
  const handleScroll = useCallback(() => {
    const threshold = window.innerWidth < 992 ? STICKY_THRESHOLD.mobile : STICKY_THRESHOLD.desktop;
    setSticky(window.scrollY >= threshold);
  }, []);

  // Scroll to All Reviews section
  const scrollToAllReviews = useCallback((type) => {
    if (allReviewsRef.current) {
      const elementPosition = allReviewsRef.current.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: elementPosition - SCROLL_OFFSET,
        behavior: 'smooth',
      });
    }
  }, []);

  // Set up scroll listener
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);
  const [showBuyAlert, setShowBuyAlert] = useState(false);
  
 const checkVerification = async (user_id) => {
    try { 
      const response = await API.post(`/business/check-verification`,{  target_user_id: user_id,});
      if (response.error_type === 1) {
        //console.log('decodeId', decodeId);
        fetchAllData(user_id);
        setUserId(user_id);
        localStorage.removeItem("redirectPath_jobcritic");
      } else {
        console.log('decodeId-', user_id);
        setUserId(user_id);
        fetchAllData(user_id,1);
        setShowBuyAlert(true);
      }
    } catch (error) {
      console.error('Error verifying account:', error);
    }
  };
  const rateNow  = async () => {
    if (!userId) return;
    const payload = {
        target_user_id: userId,
    };
    try {
        await API.post('/business/initiate-verification', payload);
        localStorage.removeItem("userData");
        window.location.href = localStorage.getItem("redirectPath_jobcritic");
    } catch (error) {
        console.error("Error initiating rating:", error);
    } finally {
      setShowBuyAlert(false);
        
    }
};
  // Set sticky height and fetch data
  useEffect(() => {
    if (stickyRef.current) {
      setStickyHeight(stickyRef.current.clientHeight);
    }
    document.body.classList.add('body-overflow-hidden');
    const decodeId = base64Decode(id);
    if (jwtTokenJobcritic) {
      checkVerification(decodeId);
    }else{
      localStorage.setItem("redirectPath_jobcritic", window.location.pathname);
      navigate("/business-login");
    }
    
    return () => document.body.classList.remove('body-overflow-hidden');
  }, [fetchAllData,id]);
const sendVerification =  () => {
  window.location.href = "/verifications";
};
  // Memoized tab menu
  const activeTabMenu = useMemo(() => (ratings.total_reviews > 0 ? TAB_MENU : DEFAULT_TAB_MENU), [
    ratings.total_reviews,
  ]);
// const decodeId = base64Decode(id);

  // Render loading state
  if (loading) {
    return (
      <div style={style}>
        <MainHeader />
        <section className="pt-[120px] sm:py-[50px] md:pt-[30px]">
          <Container>
            <Row>
              <Col lg={12}>
                <div className="flex items-end space-x-6 mb-3">
                  <Skeleton className="w-[80px] h-[80px] rounded-full" />
                  <div className="flex-1">
                    <Skeleton className="h-10 w-[180px] mb-2" />
                    <Skeleton className="h-5 w-[150px] mb-1" />
                    <Skeleton className="h-5 w-[150px]" />
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </div>
    );
  }

  // Render error state
  if (error) {
    return (
      <div style={style}>
        <MainHeader />
        <section className="pt-[120px] sm:py-[50px] md:pt-[30px]">
          <Container>
            <Row>
              <Col lg={12}>
                <div className="text-red-500">{error}</div>
              </Col>
            </Row>
          </Container>
        </section>
      </div>
    );
  }

  return (
    <div style={style}>
      <MainHeader />
      <section className="pt-[120px] overflow-hidden sm:py-[50px] md:pt-[30px]">
        <Container>
          <Row className="items-end justify-between">
            <Col lg={12} md={12} sm={12}>
              <div className="flex items-end space-x-6 mb-3">
                <Link to="/profile" className="cursor-pointer">
                  <img
                    crossorigin="anonymous"
                    src={userData.profile_image}
                    alt="User"
                    className="w-[80px] h-[80px] rounded-full object-cover border border-gray-300"
                  />
                </Link>
                <div className="flex-1 leading-[1.2]">
                  <h1 className="text-[28px] font-bold text-black mb-0 leading-tight">
                    {userData.name || 'Loading...'}
                  </h1>
                  <span className="font-medium text-[16px] text-gray-700">
                   {userData.profile_title.length > 50 ? `${userData.profile_title.substring(0, 50)}... ` : userData.profile_title || 'No title available'}
                  </span>
                  <div className="flex items-center" style={{ height: '18px' }}>
                    <StarRating rating={ratings.overall_rating} starSize={15} />
                    <span
                      className={`text-gray-600 text-[14px] ml-2 pt-[2px] ${
                        ratings.total_reviews > 0
                          ? 'cursor-pointer hover:underline hover:text-black transition'
                          : ''
                      }`}
                      onClick={() => scrollToAllReviews('all')}
                    >
                      {ratings.total_reviews > 0 ? `${ratings.total_reviews} Reviews` : 'No Reviews Yet'}
                    </span>
                    {ratings.is_ai_summary === 1 && (
                      <span className="px-2 py-[2px] text-sm font-medium yellow-b rounded-md black-class">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          width="16"
                          height="16"
                          className="inline-block mr-1"
                        >
                          <path
                            d="M10,21.236,6.755,14.745.264,11.5,6.755,8.255,10,1.764l3.245,6.491L19.736,11.5l-6.491,3.245ZM18,21l1.5,3L21,21l3-1.5L21,18l-1.5-3L18,18l-3,1.5ZM19.333,4.667,20.5,7l1.167-2.333L24,3.5,21.667,2.333,20.5,0,19.333,2.333,17,3.5Z"
                            fill="currentColor"
                          />
                        </svg>
                        AI Reviews Summary
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>

        <div style={{ height: isSticky ? `${stickyHeight}px` : 'auto' }}>
          <div
            ref={stickyRef}
            className={`w-full z-[50] transition-all duration-500 ease-in-out ${
              isSticky ? 'animated-box' : 'border-b border-t border-solid border-mediumgray'
            }`}
          >
            <Container>
              <StickTab
                data={activeTabMenu}
                userData={userData}
                ratings={ratings}
                sectionRefs={{ overviewRef, reviewsRef, academicRef, allReviewsRef }}
              />
            </Container>
          </div>
        </div>
      </section>

      <div ref={overviewRef}>
        <EmployeeReviwe showBuyAlert={showBuyAlert} ratings={ratings} mainRating={mainRating} scrollToReviews={scrollToAllReviews} type="all" />
      </div>
      <div ref={reviewsRef}>
                <About showBuyAlert={showBuyAlert} ratings={ratings} professional={professional} userData={userData} ratingsPorfin={ratingsPorfin} />
            </div>
      <div ref={reviewsRef}>
        
        <AboutSection
        showBuyAlert={showBuyAlert}
          ratings={ratings}
          professional={professional}
          ratingsPorfin={ratingsPorfin}
          scrollToReviews={scrollToAllReviews}
            userData={userData}
            user_id={userId}
          type="professional"
        />
      </div>
      <div ref={academicRef}>
        <Academic
        showBuyAlert={showBuyAlert}
          scrollToReviews={scrollToAllReviews}
          academic={academic}
          academicRatings={academicRatings}
          type="academic"
          user_id={userId}
        />
      </div>
      {ratings.total_reviews > 0 && !showBuyAlert && (
        <div ref={allReviewsRef}>
          <AllReview bg="custm-bg" showBuyAlert={showBuyAlert}  user_id={userId} />
        </div>
      )}
  <ConfinPop
    isOpen={showBuyAlert}
    onClose={() => sendVerification()}
    onConfirm={rateNow}
/>
      <FooterStyle theme="light" className="bg-black text-[#828282] seo-agency-footer_06" />
    </div>
  );
};

// PropTypes for type checking
EmployeeDetail.propTypes = {
  style: PropTypes.object,
};

export default EmployeeDetail;